/**
 * Created by Administrador on 06/05/2019.
 */
(function () {
    'use strict';

    angular
        .module('completeAir')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'CONFIG'];

    function stateConfig($stateProvider, CONFIG) {

        $stateProvider
            .state('passengerListByFlight', {
                parent: 'app',
                url: '/passengerListByFlight',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views: {
                    'main@': {
                        templateUrl: 'app/admin/report/passengerList/passengerList.html',
                        controller: 'passengerListCtrl',
                        controllerAs: 'vm',
                        resolve: {
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['passengerList']);
                            }],
                            tabs: ['tabService', function (tabService) {
                                return tabService.getTabPassengerList('passengerListByFlight')
                            }]
                        }
                    }
                }
            })
            .state('passengerListByDeparture', {
                parent: 'app',
                url: '/passengerListByDeparture',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views: {
                    'main@': {
                        templateUrl: 'app/admin/report/passengerList/passengerListByDeparture.html',
                        controller: 'passengerListByDepartureCtrl',
                        controllerAs: 'vm',
                        resolve: {
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['passengerList']);
                            }],
                            tabs: ['tabService', function (tabService) {
                                return tabService.getTabPassengerList('passengerListByDeparture')
                            }],
                            airports:['airportService',function(airportService){
                                return airportService.getAirportsActiveDisable(true);
                            }]
                        }
                    }
                }
            })
    }
})();
